import { animate, timeline as timeline2, stagger } from "//home-cooks.co.uk/cdn/shop/t/143/assets/vendor.min.js?v=161072099565793977701707219051";
(function (window, k) {
    $(document).ready(function() {
        createDateBoxes();

        var $first_page = $(".acquisition-first-page");
        var $second_page = $(".acquisition-second-page");

        $("#claim-bundle-offer").on("click", async function(e) {
            e.preventDefault();

            var buttonText = $(this).text();

            gtag('event', 'acquisition_claim_offer_click', {
                'event_category': 'Acquisition Strategy Button',
                'event_label': "claim-bundle-offer" || buttonText,
                'value': 1
            });

            var btn_msg = $("#claim-bundle-offer").text();

            var $button = $(this);
            var $contentElement = $button.find('div');
            var $animationElement = $button.find('.button__loader');

            var inputEmail = $("#email-bundle").val();
            var inputPassword = $("#password-bundle").val();

            if (!inputEmail || !inputPassword) {
                showError("Both fields are required.");
                btn_msg = $("#claim-bundle-offer").text();
                timeline2([
                    [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                ]);
                setTimeout(function(){
                    $contentElement.html(btn_msg);
                    $(".customer-referral-error").hide();
                }, 5000)
                return;
            }

            if (!validateEmail(inputEmail)) {
                showError("Use a valid email address. Offer only available for first-time customers");
                btn_msg = $("#claim-bundle-offer").text();
                timeline2([
                    [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                ]);
                setTimeout(function(){
                    $contentElement.html(btn_msg);
                    $(".customer-referral-error").hide();
                }, 5000)
                return;
            }

            timeline2([
                [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
            ]);
            animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });

            var isCustomer = await checkIfCustomerExists(inputEmail);

            if (isCustomer != 0) {
                showError("Use a valid email address. Offer only available for first-time customers");
                btn_msg = $("#claim-bundle-offer").text();
                timeline2([
                    [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                ]);
                setTimeout(function(){
                    $contentElement.html(btn_msg);
                    $(".customer-referral-error").hide();
                }, 5000)
            } else {
                var createAccountId = await createCustomerAccount(inputEmail, inputPassword);

                if (createAccountId != 0) {
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                    ]);
                    $contentElement.html('Account Created ✔');

                    setTimeout(function(){
                        $first_page.hide();
                        $second_page.css("display", "flex");
                        $('html, body').animate({
                            scrollTop: 0
                        }, 'slow');
                    }, 2000)
                } else {
                    showError("Error creating account. Please try again.");
                    btn_msg = $("#claim-bundle-offer").text();
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                    ]);
                    $contentElement.html('✖');
                    setTimeout(function(){
                        $contentElement.html(btn_msg);
                        $(".customer-referral-error").hide();
                    }, 5000)
                }
            } 
        });

        // Complete checkout
        $("#acquisition-bundle-checkout").on("click", function(e) {
            e.preventDefault();

            var buttonText = $(this).text();

            gtag('event', 'acquisition_bundle_checkout_click', {
                'event_category': 'Acquisition Strategy Button',
                'event_label': "acquisition-bundle-checkout" || buttonText,
                'value': 1
            });

            var checkoutLink = $("#checkout_link").val();
            var inputEmail = $("#email-bundle").val();
            var selectedDate = $('.date-box.selected').text();

            if (inputEmail && checkoutLink && selectedDate) {
                var encodedEmail = encodeURIComponent(inputEmail);
            
                var dateObj = parseSelectedDate(selectedDate);
                var options = { year: 'numeric', month: 'long', day: 'numeric' };
                var formattedDate = dateObj.toLocaleDateString('en-US', options);
            
                var dateParts = formattedDate.split(' ');
                var formattedDateWithoutComma = dateParts[0] + ' ' + dateParts[1].replace(',', '') + ' ' + dateParts[2];
            
                var encodedDate = encodeURIComponent(formattedDateWithoutComma);
            
                var newCheckoutLink = `${checkoutLink}checkout%255Bemail%255D%253D${encodedEmail}%2526note%253D${encodedDate}`;
            
                console.log(formattedDateWithoutComma);

                window.location.href = newCheckoutLink;
            } else {
                alert("Please ensure all information is filled correctly.");
            }
        });

        $("#browse-all-meals-1").on("click", function() {
            var buttonText = $(this).text();

            gtag('event', 'acquisition_browse_all_meals_1_click', {
                'event_category': 'Acquisition Strategy Button',
                'event_label': "browse-all-meals-1" || buttonText + "1",
                'value': 1
            });
        })

        $("#browse-all-meals-2").on("click", function() {
            var buttonText = $(this).text();
            
            gtag('event', 'acquisition_browse_all_meals_2_click', {
                'event_category': 'Acquisition Strategy Button',
                'event_label': "browse-all-meals-2" || buttonText + "2",
                'value': 1
            });
        })

        function parseSelectedDate(dateStr) {
            const [dayOfWeek, dayWithSuffix, month] = dateStr.split(' ');
            const day = parseInt(dayWithSuffix, 10);
            const year = new Date().getFullYear();
            return new Date(`${month} ${day} ${year}`);
        }

        function createDateBoxes() {
            const dateContainer = $('#dateContainer');
            const dates = getNextFiveBusinessDays();

            dates.forEach((date, index) => {
                const dateBox = $('<div>', {
                    class: 'date-box',
                    text: formatDateCustom(date)
                }).on('click', () => selectDate(index));
                if (index === 0) {
                    dateBox.addClass('selected');
                    updateWeekDays(date);
                }
                dateContainer.append(dateBox);
            });
        }

        function selectDate(index) {
            const dates = getNextFiveBusinessDays();
            const selectedDate = dates[index];
            updateWeekDays(selectedDate);
        
            $('.date-box').removeClass('selected');
            $('.date-box').eq(index).addClass('selected');
        }

        function updateWeekDays(startDate) {
            console.log("week days update");
            const firstWeekDay = new Date(startDate);
            const secondWeekDay = new Date(startDate);
            secondWeekDay.setDate(firstWeekDay.getDate() + 7);
            const thirdWeekDay = new Date(startDate);
            thirdWeekDay.setDate(firstWeekDay.getDate() + 14);

            $("#first-week-day").text(formatDateMonthDay(firstWeekDay));
            $("#second-week-day").text(formatDateMonthDay(secondWeekDay));
            $("#third-week-day").text(formatDateMonthDay(thirdWeekDay));
        }

        function formatDateMonthDay(date) {
            const options = { month: 'long', day: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        }

        function formatDateCustom(date) {
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            const dayOfWeek = days[date.getDay()];
            const day = date.getDate();
            const suffix = getDaySuffix(day);
            const month = date.toLocaleString('en-US', { month: 'short' });
            return `${dayOfWeek} ${day}${suffix} ${month}`;
        }
        
        function getDaySuffix(day) {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }

        function getNextFiveBusinessDays() {
            const result = [];
            let count = 0;
            let day = new Date();

            // Add 2 days buffer
            day.setDate(day.getDate() + 1);

            while (result.length < 5) {
                day.setDate(day.getDate() + 1);
                if (day.getDay() !== 0 && day.getDay() !== 3 && day.getDay() !== 6) { // Skip weekends and wed
                    result.push(new Date(day));
                }
            }
            return result;
        }

        function showError(message) {
            $(".customer-referral-error .banner").text(message);
            $(".customer-referral-error").show();
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
            return re.test(String(email).toLowerCase());
        }

        async function checkIfCustomerExists(email) {
            try {
                const data = await makeRequestAPI(`admin/api/2024-04/customers/search.json?query=email:${email}`, 'GET');
                return data.customers.length;
            } catch (error) {
                console.error('Erro ao obter informações do cliente:', error);
                return 0;
            }
        }

        async function createCustomerAccount(email, password) {
            try {
                const bodyData = {
                    "customer":{
                       "email":email,
                       "verified_email":true,
                       "password":password,
                       "password_confirmation":password,
                       "send_email_welcome":false
                    }
                };
                const data = await makeRequestAPI('admin/api/2024-01/customers.json', 'POST', bodyData);
                return data.customer.id;
            } catch (error) {
                console.error('Error creating customer:', error);
                return 0;
            }
        }

        function makeRequestAPI(endpoint, method, data = null) {
            const url = `https://api.home-cooks.co.uk/shopify-api.php?endpoint=${endpoint}&method=${method}`;
            
            var options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            if (method === 'POST' && data) {
                options.method = 'POST';
                options.body = JSON.stringify(data);
            }

            return fetch(url, options)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Erro ao fazer requisição para a API');
                    }
                    return response.json();
                })
                .then(data => {
                    return data;
                })
                .catch(error => {
                    console.error('Erro:', error);
                    return null;
                });
        }
    });
})(window);
